import type { LocalityData, LocalitySuggestionData } from 'service/locality/model';
import { DEFAULT_RADIUS_VALUE, getKnownLocalityByLocality, LOCALITY_CELA_CR } from 'utils/constants';

export function getDefaultRadius() {
	// This used to return different values based on some arbitrary stuff. Keeping this function here in case
	// product changes their mind again.
	return DEFAULT_RADIUS_VALUE;
}

export function getKdeParameter(locality: LocalityData | LocalitySuggestionData) {
	if (!locality || locality.entityId === LOCALITY_CELA_CR.id) {
		return undefined;
	}

	const knownLocality = getKnownLocalityByLocality(locality);
	return knownLocality ? undefined : `${locality.entityType[0]}${locality.entityId}`;
}
